import html from "html-literal";
export default () => html`
  <footer>
    By Lucy
  </footer>
`;
